var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHomeBooking = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 109,
    viewBox: "0 0 105 121",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_210_9887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3292 25.7224C67.1675 25.7224 79.2142 37.7692 79.2142 52.6075V53.4795C79.2142 68.3178 67.1675 80.3646 52.3292 80.3646C37.4909 80.3646 25.4441 68.3178 25.4441 53.4795V52.6075C25.4441 37.7692 37.4909 25.7224 52.3292 25.7224Z",
    fill: "#262FED"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4995 12C72.0933 12 88 27.9067 88 47.4995V48.651C88 68.2437 72.0933 84.1505 52.5005 84.1505C32.9067 84.1515 17 68.2437 17 48.651V47.4995C17 27.9067 32.9067 12 52.4995 12Z",
    fill: "#262FED"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_9887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5003 32.8771C52.0413 32.8771 51.6687 32.5046 51.6687 32.0455V25.8319C51.6687 25.3728 52.0413 25.0002 52.5003 25.0002C52.9594 25.0002 53.332 25.3728 53.332 25.8319V32.0445C53.332 32.5035 52.9594 32.8761 52.5003 32.8761V32.8771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5003 71.9987C52.0413 71.9987 51.6687 71.6261 51.6687 71.167V64.9544C51.6687 64.4954 52.0413 64.1228 52.5003 64.1228C52.9594 64.1228 53.332 64.4954 53.332 64.9544V71.167C53.332 71.6261 52.9594 71.9987 52.5003 71.9987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1687 49.3322H68.9562C68.4971 49.3322 68.1245 48.9596 68.1245 48.5006C68.1245 48.0415 68.4971 47.6689 68.9562 47.6689H75.1687C75.6278 47.6689 76.0004 48.0415 76.0004 48.5006C76.0004 48.9596 75.6278 49.3322 75.1687 49.3322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0463 49.3322H29.8316C29.3726 49.3322 29 48.9596 29 48.5006C29 48.0415 29.3726 47.6689 29.8316 47.6689H36.0463C36.5053 47.6689 36.8779 48.0415 36.8779 48.5006C36.8779 48.9596 36.5053 49.3322 36.0463 49.3322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8131 39.6361C68.6217 39.6361 68.4354 39.5362 68.3324 39.3572C68.1801 39.0926 68.2707 38.752 68.5362 38.5996L71.8535 36.6831C72.1129 36.5267 72.4587 36.6214 72.6111 36.8869C72.7634 37.1515 72.6728 37.4921 72.4073 37.6445L69.09 39.5609C69.0035 39.6104 68.9068 39.6351 68.8131 39.6351V39.6361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8695 60.3892C32.6781 60.3892 32.4918 60.2894 32.3888 60.1103C32.2365 59.8458 32.3271 59.5051 32.5926 59.3528L35.912 57.4363C36.1744 57.2819 36.5151 57.3704 36.6695 57.6401C36.8218 57.9046 36.7313 58.2453 36.4657 58.3976L33.1464 60.3141C33.0599 60.3635 32.9632 60.3882 32.8695 60.3882V60.3892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9183 32.7431C61.8246 32.7431 61.7289 32.7184 61.6414 32.669C61.3749 32.5167 61.2853 32.176 61.4376 31.9115L63.3541 28.5921C63.5054 28.3245 63.8471 28.236 64.1117 28.3883C64.3782 28.5406 64.4678 28.8813 64.3154 29.1458L62.399 32.4652C62.296 32.6443 62.1097 32.7441 61.9183 32.7441V32.7431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1671 68.686C41.0734 68.686 40.9777 68.6613 40.8902 68.6119C40.6236 68.4596 40.5341 68.1189 40.6864 67.8544L42.6029 64.535C42.7552 64.2674 43.0939 64.1799 43.3604 64.3312C43.627 64.4835 43.7166 64.8242 43.5642 65.0887L41.6477 68.4081C41.5448 68.5872 41.3585 68.687 41.1671 68.687V68.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8346 68.6858C63.6431 68.6858 63.4568 68.586 63.3539 68.4069L61.4374 65.0875C61.2851 64.823 61.3757 64.4823 61.6412 64.33C61.9016 64.1787 62.2444 64.2662 62.3987 64.5338L64.3152 67.8531C64.4675 68.1177 64.377 68.4583 64.1114 68.6107C64.025 68.6601 63.9282 68.6848 63.8346 68.6848V68.6858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0821 32.7427C42.8907 32.7427 42.7044 32.6428 42.6015 32.4637L40.685 29.1444C40.5326 28.8799 40.6232 28.5392 40.8888 28.3868C41.1533 28.2345 41.494 28.323 41.6463 28.5906L43.5628 31.91C43.7151 32.1745 43.6245 32.5152 43.359 32.6675C43.2725 32.7169 43.1758 32.7416 43.0821 32.7416V32.7427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1306 60.3902C72.037 60.3902 71.9412 60.3655 71.8537 60.3161L68.5365 58.3996C68.2699 58.2473 68.1803 57.9066 68.3327 57.6421C68.485 57.3724 68.8257 57.2839 69.0902 57.4383L72.4075 59.3547C72.6741 59.5071 72.7636 59.8477 72.6113 60.1123C72.5084 60.2914 72.3221 60.3912 72.1306 60.3912V60.3902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1891 39.6365C36.0954 39.6365 35.9997 39.6118 35.9122 39.5624L32.5929 37.6459C32.3263 37.4936 32.2367 37.1529 32.3891 36.8884C32.5404 36.6218 32.8821 36.5281 33.1466 36.6846L36.4659 38.6011C36.7325 38.7534 36.8221 39.0941 36.6697 39.3586C36.5668 39.5377 36.3805 39.6375 36.1891 39.6375V39.6365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6507 51.1814C50.4377 51.1814 50.2246 51.1011 50.062 50.9385C49.7378 50.6143 49.7378 50.0853 50.062 49.761L60.6479 39.1751C60.9742 38.8489 61.4991 38.8489 61.8254 39.1751C62.1517 39.5014 62.1496 40.0284 61.8254 40.3526L51.2395 50.9385C51.0758 51.1022 50.8638 51.1814 50.6507 51.1814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8794 51.1418C53.6664 51.1418 53.4533 51.0615 53.2907 50.8989L48.0374 45.6456C47.7131 45.3213 47.7131 44.7923 48.0374 44.4681C48.3636 44.1418 48.8885 44.1418 49.2148 44.4681L54.4681 49.7214C54.7924 50.0456 54.7924 50.5747 54.4681 50.8989C54.3045 51.0625 54.0925 51.1418 53.8794 51.1418Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_210_9887",
    x: 0.444092,
    y: 0.722412,
    width: 103.77,
    height: 104.642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_210_9887"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_9887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 46.9979,
    fill: "white",
    transform: "translate(29 25)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHomeBooking, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home-booking.c47a6019.svg";
export { ForwardRef as ReactComponent };